import React from 'react';
import styled from 'react-emotion';

const BulletContainer = styled.span`
  width: 42px;
  display: inline-block;
  
  .ball {
    display: inline-block;
    height: 21px;
    width: 21px;
    border-radius: 50%;
    background: linear-gradient(#59e1d5, #52b5e9);;
  }
`;

const Bullet = () => (
  <BulletContainer><span className='ball' /></BulletContainer>
);

export default Bullet;



// WEBPACK FOOTER //
// ./src/components/bullet.jsx